import { useCallback, useState } from 'react';

const STORAGE_KEY = 'banquinha_welcome_tour_completed';

export function useWelcomeTour() {
  const [hasSeenTour, setHasSeenTour] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  const completeTour = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setHasSeenTour(true);
  }, []);

  const resetTour = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setHasSeenTour(false);
  }, []);

  return {
    hasSeenTour,
    completeTour,
    resetTour,
  };
}
